import { Card, CardContent, CardDescription, CardHeader, CardMeta, Icon, Image } from "semantic-ui-react";
import styles from './MainPage.module.css';
const Card3 = () => {

    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader><center>Клуб охотников</center></CardHeader>
                <CardMeta>
                    <a href="/club"><Image src="./assets/clublogo.png" fluid centered /></a>
                </CardMeta>
            </CardContent>
        </Card>
    );
}

export default Card3